import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import './index.css';

ReactDOM.render(
  <Provider store={store}>
    <ToastProvider autoDismiss placement='bottom-center'>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ToastProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
